module.exports = __webpack_public_path__ + "img/section-2-5.afb14ba.webp";